export type AssetCustomFieldUnitOption = {
  value: string;
  label: string;
};

export type AssetCustomFieldUnitOptionGroup = {
  label: string;
  options: AssetCustomFieldUnitOption[];
};

export const DEFAULT_UNIT_GROUPS: AssetCustomFieldUnitOptionGroup[] = [
  {
    label: 'Electrical',
    options: [
      { value: 'V', label: 'Volt (V)' },
      { value: 'mV', label: 'Millivolt (mV)' },
      { value: 'kV', label: 'Kilovolt (kV)' },
      { value: 'A', label: 'Ampere (A)' },
      { value: 'mA', label: 'Milliampere (mA)' },
      { value: 'W', label: 'Watt (W)' },
      { value: 'kW', label: 'Kilowatt (kW)' },
      { value: 'MW', label: 'Megawatt (MW)' },
      { value: 'Wh', label: 'Watt-hour (Wh)' },
      { value: 'kWh', label: 'Kilowatt-hour (kWh)' },
      { value: 'MWh', label: 'Megawatt-hour (MWh)' },
      { value: 'Hz', label: 'Hertz (Hz)' },
      { value: 'Ω', label: 'Ohm (Ω)' },
      { value: 'kΩ', label: 'Kilohm (kΩ)' },
      { value: 'Ah', label: 'Ampere-hour (Ah)' },
      { value: 'mAh', label: 'Milliampere-hour (mAh)' },
      { value: 'PF', label: 'Power factor (PF)' },
    ],
  },
  {
    label: 'Temperature',
    options: [
      { value: '°C', label: 'Degree Celsius (°C)' },
      { value: '°F', label: 'Degree Fahrenheit (°F)' },
      { value: 'K', label: 'Kelvin (K)' },
      { value: 'Δ°C', label: 'Temperature delta (°C)' },
      { value: 'Δ°F', label: 'Temperature delta (°F)' },
    ],
  },
  {
    label: 'Environmental',
    options: [
      { value: '%', label: 'Percent (%)' },
      { value: '%RH', label: 'Relative humidity (%RH)' },
      { value: 'ppm', label: 'Parts per million (ppm)' },
      { value: 'lux', label: 'Lux (lx)' },
      { value: 'dB', label: 'Decibel (dB)' },
      { value: 'dBA', label: 'A-weighted decibel (dBA)' },
    ],
  },
  {
    label: 'Pressure',
    options: [
      { value: 'Pa', label: 'Pascal (Pa)' },
      { value: 'kPa', label: 'Kilopascal (kPa)' },
      { value: 'bar', label: 'Bar (bar)' },
      { value: 'mbar', label: 'Millibar (mbar)' },
      { value: 'psi', label: 'Pound per square inch (psi)' },
      { value: 'atm', label: 'Atmosphere (atm)' },
    ],
  },
  {
    label: 'Distance & Size',
    options: [
      { value: 'mm', label: 'Millimeter (mm)' },
      { value: 'cm', label: 'Centimeter (cm)' },
      { value: 'm', label: 'Meter (m)' },
      { value: 'km', label: 'Kilometer (km)' },
      { value: 'in', label: 'Inch (in)' },
      { value: 'ft', label: 'Foot (ft)' },
      { value: 'mi', label: 'Mile (mi)' },
    ],
  },
  {
    label: 'Mass & Weight',
    options: [
      { value: 'mg', label: 'Milligram (mg)' },
      { value: 'g', label: 'Gram (g)' },
      { value: 'kg', label: 'Kilogram (kg)' },
      { value: 't', label: 'Tonne (t)' },
      { value: 'lb', label: 'Pound (lb)' },
    ],
  },
  {
    label: 'Volume & Flow',
    options: [
      { value: 'mL', label: 'Millilitre (mL)' },
      { value: 'L', label: 'Litre (L)' },
      { value: 'm³', label: 'Cubic metre (m³)' },
      { value: 'L/min', label: 'Litre per minute (L/min)' },
      { value: 'L/h', label: 'Litre per hour (L/h)' },
      { value: 'm³/h', label: 'Cubic metre per hour (m³/h)' },
      { value: 'gal', label: 'Gallon (gal)' },
    ],
  },
  {
    label: 'Speed & Acceleration',
    options: [
      { value: 'm/s', label: 'Metre per second (m/s)' },
      { value: 'km/h', label: 'Kilometre per hour (km/h)' },
      { value: 'mph', label: 'Miles per hour (mph)' },
      { value: 'rpm', label: 'Revolutions per minute (rpm)' },
      { value: 'm/s²', label: 'Metre per second squared (m/s²)' },
    ],
  },
  {
    label: 'Time & Frequency',
    options: [
      { value: 'ms', label: 'Millisecond (ms)' },
      { value: 's', label: 'Second (s)' },
      { value: 'min', label: 'Minute (min)' },
      { value: 'h', label: 'Hour (h)' },
      { value: 'd', label: 'Day (d)' },
      { value: 'kHz', label: 'Kilohertz (kHz)' },
    ],
  },
  {
    label: 'Currency',
    options: [
      { value: 'EUR', label: 'Euro (€)' },
      { value: 'USD', label: 'US dollar ($)' },
      { value: 'GBP', label: 'Pound sterling (£)' },
    ],
  },
];

export const DEFAULT_UNIT_VALUES = DEFAULT_UNIT_GROUPS.flatMap((group) =>
  group.options.map((option) => option.value),
);
